/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

$section-padding-top-desktop-large: 88px !default;
$section-padding-bottom-desktop-large: 88px !default;
$section-padding-top-desktop: 72px !default;
$section-padding-bottom-desktop: 72px !default;
$section-padding-top-tablet: 64px !default;
$section-padding-bottom-tablet: 64px !default;
$section-padding-top-phone: 56px !default;
$section-padding-bottom-phone: 56px !default;
$section-padding-top-footer: 48px !default;
$section-padding-bottom-footer: 64px !default;
$section-margin-phone: 24px !default;
$section-margin-tablet: 32px !default;
$section-margin-desktop: 48px !default;
$section-margin-desktop-large: 48px !default;
$section-h-gutter-phone: 16px !default;
$section-h-gutter-tablet: 24px !default;
$section-h-gutter-desktop: 40px !default;
$section-h-gutter-desktop-large: 48px !default;

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
}

* {
  margin: 0;
  padding: 0;
}

*,
*::after,
*::before {
  box-sizing: border-box;
  outline: 0 none;
  text-rendering: optimizelegibility;
}

.#{$prefix}section-wrapper {
  position: relative;
  background: v(bgColor);

  &.#{$prefix}gradient {
    background: v(gradientColor);
  }

  // Gradient background only works in default mode and not in offset mode. Reason: Cannot use gradient inside of gradient.
  &.#{$prefix}background-offset {
    @include for-size(desktop-l) {
      background: v(bgColor);
      background: linear-gradient(
        0deg,
        var(--nextSectionBackgroundColor) 0%,
        var(--nextSectionBackgroundColor) 80px,
        v(bgColor) 80px,
        v(bgColor) 100%
      );
    }
  }

  .#{$prefix}section-inner {
    position: relative;
    max-width: calc($content-max-width-desktop-l + $section-margin-desktop-large * 2);
    height: auto;
    padding-top: $section-padding-top-desktop-large;
    padding-left: $section-margin-desktop-large;
    padding-bottom: $section-padding-bottom-desktop-large;
    padding-right: $section-margin-desktop-large;
    margin: 0px auto 0px auto;

    @include for-size(desktop) {
      max-width: calc($content-max-width-desktop + $section-margin-desktop * 2);
      padding-top: $section-padding-top-desktop;
      padding-right: $section-margin-desktop;
      padding-bottom: $section-padding-bottom-desktop;
      padding-left: $section-margin-desktop;
    }

    @include for-size(tablet) {
      max-width: 100%;
      padding-top: $section-padding-top-tablet;
      padding-right: $section-margin-tablet;
      padding-bottom: $section-padding-bottom-tablet;
      padding-left: $section-margin-tablet;
    }

    @include for-size(phone) {
      max-width: 100%;
      padding-top: $section-padding-top-phone;
      padding-right: $section-margin-phone;
      padding-bottom: $section-padding-bottom-phone;
      padding-left: $section-margin-phone;
    }

    eon-ui-button {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 48px;
    }
  }

  &.#{$prefix}remove-top-padding {
    .#{$prefix}section-inner {
      padding-top: 0;
    }
  }

  &.#{$prefix}remove-bottom-padding {
    .#{$prefix}section-inner {
      padding-bottom: 0;
    }
  }

  &.#{$prefix}full-width {
    .#{$prefix}section-inner {
      padding-left: 0;
      padding-right: 0;
    }
  }

  &.#{$prefix}stretch-grid {
    .#{$prefix}section-inner {
      max-width: 1920px;
    }
  }

  &.#{$prefix}stretch-grid {
    &.#{$prefix}full-width {
      .#{$prefix}section-inner {
        max-width: 1920px;
        padding-left: 0;
        padding-right: 0;
      }
    }
  }

  &.#{$prefix}section-in-section {
    .#{$prefix}section-inner {
      padding: 48px;

      @include for-size(desktop) {
        padding: 40px;
      }

      @include for-size(tablet) {
        padding: 32px;
      }

      @include for-size(phone) {
        padding: 24px;
      }
    }
  }
}

footer.#{$prefix}section-wrapper {
  .#{$prefix}section-inner {
    padding-top: $section-padding-top-footer;
    padding-bottom: $section-padding-bottom-footer;

    .#{$prefix}footer-separator {
      position: absolute;
      top: 0;
      background: v(footerSeparatorColor);
      height: 4px;
      width: calc(100% - 2 * $section-margin-desktop-large);

      @include for-size(desktop) {
        width: calc(100% - 2 * $section-margin-desktop);
      }

      @include for-size(tablet) {
        width: calc(100% - 2 * $section-margin-tablet);
      }

      @include for-size(phone) {
        width: calc(100% - 2 * $section-margin-phone);
      }
    }
  }
}

::slotted(eon-ui-grid-control) {
  margin-bottom: $section-h-gutter-desktop-large !important;

  @include for-size(desktop) {
    margin-bottom: $section-h-gutter-desktop !important;
  }

  @include for-size(tablet) {
    margin-bottom: $section-h-gutter-tablet !important;
  }

  @include for-size(phone) {
    margin-bottom: $section-h-gutter-phone !important;
  }
}

::slotted(eon-ui-grid-control[remove-bottom-spacings]) {
  margin-bottom: 0 !important;
}

::slotted(eon-ui-grid-control:last-child) {
  margin-bottom: 0 !important;
}
